<template>
    <div  class="page update-page">
        <Header title="修改关键信息" :show-back="true" class="nav" />
        <div class="content">
            <van-form :show-error="false" @submit="submit">
              <van-field
                v-model="params.clientName"
                name="公司名称"
                label="公司名称"
                placeholder="请输入公司名称"
                :rules="[{ required: true, message: '请输入公司名称' }]"
              />
              <van-field
                v-model="params.contactPerson"
                name="姓名"
                label="姓名"
                placeholder="请输入姓名"
                :rules="[{ required: true, message: '请输入姓名' }]"
              />
              <van-field v-model="params.verifyCode" type="number" label="验证码"
                placeholder="请输入验证码"
                :rules="[{ required: true, message: '请输入验证码' }]" >
                <template #button>
                  <div :style="disableSendBtn?'color:grey':'color:#00545e'" @click="getVerifyCode">获取验证码{{countDownText}}</div>
                </template>
              </van-field>

              <div class="register-field">
                <div class="register-field-title">请上传申请表</div>
                <!-- <div class="field-btn">下载申请表</div> -->
                <van-uploader v-model="fileList" :max-count="1" :after-read="afterRead"  @delete="handleDelete">
                  <div class="upload-icon"> + </div>
                </van-uploader>
              </div>
              <div style="margin: 16px;">
                <van-button color="#00545e" block type="info" native-type="submit">提交修改</van-button>
              </div>
            </van-form>
        </div>

        <van-overlay :show="hintOverlay" @click="hintOverlay = false">
          <div class="wrapper-overlay" @click.stop>
            <div class="content-overlay">
              <div class="overlay-cancel" @click="hintOverlay = false">x</div>
              <div class="content-title">是否修改信息？</div>
              <div class="overlay-block"></div>
              <div class="overlay-btn" @click="hintOverlay = false">取消</div>
              <div class="overlay-btn" @click="updateSuccess()">确定</div>
              <!-- <img src="../dialog-bg.png"></img> -->
            </div>
          </div>
        </van-overlay>

    </div>
</template>

<script>
import Header from '@/components/header'
import { userUtils } from '@/utils/auth'
import { mapState } from 'vuex'
import centerApi from '../../api/center'
import fileApi from '../../api/file'
import validators from '@/utils/validators'
export default {
  components: {
    Header
  },
  data () {
    var checkPassword = validators.checkPassword
    var checkEmail = validators.checkEmail
    var checkMobile = validators.checkMobile
    var checkPasswordAgain = (val) => {
      if (val !== this.params.password) {
        return false
      }
    }
    return {
      params: {
        verifyCode: '',
        clientName: '',
        contactPerson: '',
        contactMobile: '',
        authorizeFileId: ''
      },
      detailAddress: '',
      showArea: false,
      areaList: {},
      newProvinceArray: [],
      newCityArray: [],
      newCountyArray: [],
      countyArray: [],
      provinceId: 0,
      cityId: 0,
      countyId: 0,
      columns: [{ values: [] }, { values: [] }, { values: [] }],
      showPicker: false,
      value: '',
      fileList: [],
      authorizeFileId: '',
      disableSendBtn: false,
      countDownIndex: 0,
      registerOverlay: false,
      selectOverlay: false,
      clientList: [],
      hintOverlay: false,
      rules: {
        passwordRule: [{ required: true, validator: checkPassword, message: '密码必须由8-12位数字,大小写字母和特殊字符其中三种组成' }],
        passwordAgainRule: [{ required: true, validator: checkPasswordAgain, message: '两次密码输入不一致' }],
        mobileRule: [{ required: true, validator: checkMobile, message: '请输入正确手机号' }],
        emailRule: [{ required: true, validator: checkEmail, message: '请输入正确邮箱' }]
      }
    }
  },
  computed: {
    ...mapState({
      provinceArray: state => state.base.provinceArray,
      cityArray: state => state.base.cityArray
    }),

    countDownText () {
      return this.countDownIndex > 0 ? '(' + this.countDownIndex + ')' : ''
    }
  },
  created () {
    this.userInfo = userUtils.getClientInfo()
    this.params.clientName = this.userInfo.clientName
    this.params.contactPerson = this.userInfo.clientUserDTO.userName
  },
  methods: {
    gotoLogin (contactMobile, clientId) {
      this.$router.push({ name: 'login2', query: { contactMobile, clientId } })
    },
    getVerifyCode () {
      if (this.disableSendBtn) {
        return
      }
      centerApi.clientUpdateGeneralVerifyCode().then(res => {
        if (res.data.resultCode === '0') {
          this.countDownIndex = 60
          this.disableSendBtn = true
          this.countDown()
        }
      })
    },
    countDown () {
      this.countDownIndex = 60
      let _vm = this
      let timer = setInterval(() => {
        _vm.countDownIndex--
        if (_vm.countDownIndex === 0) {
          _vm.disableSendBtn = false
          clearInterval(timer)
        }
      }, 1000)
    },
    afterRead (file) {
      fileApi
        .uploadFilePublic(file.file)
        .then((response) => {
          if (response.data.resultCode === '0') {
            let fileDTO = response.data.resultData.fileDTO
            this.params.authorizeFileId = fileDTO.fileId
          }
        })
        .catch(() => {
        })
    },
    handleDelete () {
      this.params.authorizeFileId = ''
    },
    updateSuccess () {
      if (!this.params.authorizeFileId) {
        this.$toast('请上传申请表！')
        return
      }
      this.params.clientId = this.userInfo.clientId
      centerApi.clientUpdateKey(this.params).then(res => {
        if (res.data.resultCode === '0') {
          this.hintOverlay = false
          setTimeout(() => {
            this.$router.push({ name: 'personal-data' })
          }, 1000)
          this.$toast('提交修改成功！')
        }
      })
      this.hintOverlay = false
    },
    submit () {
      if (!this.params.authorizeFileId) {
        this.$toast('请上传申请表！')
        return
      }
      this.hintOverlay = true
    }
  }
}
</script>
<style lang="less" scoped>
.register-field{
  margin:20px  15px;
  .register-field-title{
    font-weight:bolder;
    font-size: 16px;
  }
}
.field-btn{
  position: absolute;
  right: 15px;
  line-height: 40px;
  color:#00545e
}
.notice-bar{
  display: flex;
  background-color: rgb(238, 236, 203);
  padding: 6px 10px;
  color: rgb(182, 157, 16);
  margin:15px;
  width: calc(100% - 50px);
  border-radius: 5px;
  justify-content: space-between;
}
.upload-icon{

  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: dashed 2px rgb(190, 190, 190);
  font-size: 30px;
  text-align: center;
  color: rgb(190, 190, 190);
}
.van-uploader{
  margin-top: 15px;
}
.wrapper-overlay{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.content-overlay{
  background-image: url(../../assets/images/dialog-bg.png);
  background-size: 100%;
  background-repeat: no-repeat;
  width: 80%;
  background-color: #fff;
  border-radius: 14px;
  img{
    width: 100%;
  }
  .overlay-cancel{
    color: #fff;
    font-size: 80px;
    position: absolute;
    right: 0px;
  }
  .content-title{
    font-size: 19px;
    text-align: center;
    color: white;
    margin: 25px 0 15px 0;
  }
  .content-info{
    background-color: rgb(255, 255, 255);
    width: 86%;
    margin-left: 7%;
    padding-bottom: 10px;
    z-index: 10;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    box-shadow: 0px 0px 0px 0px #f1f1f1,
    0px 0px 2px 0px #f1f1f1,
    0px 0px 2px 0px #f1f1f1,
    0px 2px 13px 0px #f1f1f1;
    .overlay-icon{
      padding-top: 20px;
    }
  }
    .overlay-btn{
    text-align: center;
    font-size: 18px;
    color: var(--base-green);
    padding: 15px 0 20px 0;
    display: inline-block;
    width: 50%;
  }
  .content-info-client{
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    text-align: left !important;
    color: var(--base-green);
    font-size: 14px;
    padding-left: 10px;
  }

  .content-info-client-name{
    font-weight: 600;
  }
  .content-info-client-right{
    font-size: 14px;
    line-height: 18px !important;
    padding: 15px 10px 0 0 ;
  }
  .content-info-client-code{
    font-size: 12px;
  }
}
</style>
